import Container from '@/components/@base/container';
import useCommonModalStore from '@/store/common-modal-store';
import whiteLogo from '@/assets/logos/payment-isnot-complete-light.svg';
import darkLogo from '@/assets/logos/payment-isnot-complete-dark.svg';
import { Text } from '@/components/@base/typography';
import { SIZE_ENUM } from '@/components/@base/@types';
import localization from '@/constant/localization';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';

const FailedPayment = () => {
  const {setShow} = useCommonModalStore()
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()
  function removeIpgStatus() {
    if(searchParams.has('IPGStatus') && searchParams.has('pgc')){
      navigate(`/?pgc=${searchParams.get('pgc')}`)
    }
  }
  const handleClose = () => {
    setShow(false)
    removeIpgStatus()
  }

  return <Container center className='flex-col'>
    <img src={whiteLogo} alt='cancel payment' className='dark:hidden my-4'/>
    <img src={darkLogo} alt='cancel payment' className='hidden dark:block my-4'/>
    <Text medium size={SIZE_ENUM.MD} className='text-grayLight-1000 dark:text-grayLight-0 mb-2'>{localization.paymentIsNotComplete}</Text>
    <Text size={SIZE_ENUM.SM} className='text-grayLight-600 dark:text-[#CCCCD1] mb-8'>{localization.paymentIsNotCompleteInIPG}</Text>
    <Container center className='border-t border-grayLight-100 dark:border-grayDark-700 w-full py-4 text-grayLight-1000 hover:bg-grayLight-1000/10 dark:text-white cursor-pointer' onClick={handleClose}>
      {localization.iGetIt}
    </Container>
  </Container>
}

export default FailedPayment